// extracted by mini-css-extract-plugin
module.exports = {"ooccApp":"overpayment-calculator_ooccApp__E4T8C"};